
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Circle = styled.div`
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 1px 10px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #87A6C6;
  border: 1px solid #87A6C6;
  border-radius: 10px;
  margin-right: 5px;
`;

const ActiveCircle = styled(Circle)`
  background-color: #6AE2CE;
  border: 1px solid #6AE2CE;
`;

const StyledWrap = styled.div`
  top: 101%;
  display: table;
  margin: 0 auto;
  padding-top: 15px;
  z-index: 15;
`;

function Pagination({ length, activeItem, onClick }) {
  return (
    <StyledWrap>
      {
        _.range(length).map(i => ((activeItem === i) ?
          <ActiveCircle
            key={i}
            onClick={() => onClick(i)}
          /> : <Circle
            key={i}
            onClick={() => onClick(i)}
          />
        ))
      }
    </StyledWrap>
  );
}

Pagination.propTypes = {
  activeItem: PropTypes.number,
  length: PropTypes.number,
};

Pagination.defaultProps = {
  activeItem: 0,
  length: 0,
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/landing/FeatureCarousel/CarouselControl/Pagination.js